import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@/app/providers";
import { router } from "@/router";

import "@/styles/app.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error(
    "No se encontró el elemento #root. Revisa que index.html no haya cambiado.",
  );
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
